export default __webpack_public_path__ + "static/media/17.546eda30.mp3";